import { GuardProvider } from 'react-router-guards'
import { RouteFactory } from './route-factory'
import { guardsRoutes } from './utils/functions'

// Layouts base
import { BaseLayout, LoginLayout, BlankLayout } from '../layouts'

// Pages
import {
  Signin,
  Signup,
  SignupPassword,
  ForgotPassword,
  ConfirmEmail,
  RecoverPassword,
  Home,
  MyData,
  ChangePassword,
  MyClients,
  MyClientsServices,
  MyClientsRegistrationData,
  PsychologicalInterview,
  TestApplication,
  BehavioralObservation,
  Reports,
  Attests,
  Record,
  Opinion,
  Declaration,
  Documents,
  Document,
  Construtos,
  Construto,
  Tests,
  Test,
  Factors,
  Factor,
  FirstSteps,
  SubscribePrices,
  PageNotFound,
  MedicalRegister
} from '../../presentation/pages'
import BilingFactory from '../factories/billing'
import NewTest from '../../presentation/components/new-test'
import CreateTestFactory from '../factories/create-test'
import NewConstruct from '../../presentation/components/new-construct'
import CreateConstructFactory from '../factories/create-construct'
import ConstructXTest from '../../presentation/components/test-x-contruct'
import PhoneImport from '../../presentation/pages/import-from-phone'
import InternalSession from '../../presentation/pages/my-clients/internal/session'
import RelevantFactInternal from '../../presentation/pages/my-clients/internal/relevant-fact'
import InternalAssessment from '../../presentation/pages/my-clients/internal/assessment'

const Routes = () => {
  const routes = [
    {
      layout: BlankLayout,
      pages: [
        // { path: "*", component: PageNotFound },
        { path: '/401', component: PageNotFound },
        { path: '/403', component: PageNotFound },
        { path: '/404', component: PageNotFound },
        {
          path: '/importar-arquivo/:cdBloco/:cdPsicologo',
          component: PhoneImport
        }
      ]
    },
    {
      layout: LoginLayout,
      pages: [
        { path: '/login', component: Signin },
        { path: '/cadastro', component: Signup },
        { path: '/cadastro-senha', component: SignupPassword },
        { path: '/esqueceu-senha', component: ForgotPassword },
        { path: '/confirmar-email', component: ConfirmEmail },
        { path: '/recuperar-senha', component: RecoverPassword }
      ]
    },
    {
      layout: BaseLayout,
      pages: [
        { path: '/', component: Home, meta: { auth: true } },
        { path: '/meus-dados', component: MyData, meta: { auth: true } },
        {
          path: '/alterar-senha',
          component: ChangePassword,
          meta: { auth: true }
        },
        {
          path: '/meu-faturamento',
          component: BilingFactory,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes',
          component: MyClients,
          meta: { auth: true }
        },
        {
          path: '/minha-assinatura',
          component: SubscribePrices,
          meta: { auth: true }
        },
        {
          path: '/primeiros-passos',
          component: FirstSteps,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/dados-cadastrais',
          component: MyClientsRegistrationData,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/dados-cadastrais',
          component: MyClientsRegistrationData,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/servicos',
          component: MyClientsServices,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/prontuario',
          component: MedicalRegister,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/:idassessment',
          component: InternalAssessment,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/sessao/:idsessao',
          component: InternalSession,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/fato-relevante/:idFatoRelevante',
          component: RelevantFactInternal,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/entrevista/:idassessment/:flag',
          component: PsychologicalInterview,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/aplicacao-de-teste/:idassessment',
          component: TestApplication,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/observacao-comportamental/:idassessment',
          component: BehavioralObservation,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/laudo/:idassessment',
          component: Reports,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/atestado/:idassessment',
          component: Attests,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/relatorio/:idassessment',
          component: Record,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/parecer/:idassessment',
          component: Opinion,
          meta: { auth: true }
        },
        {
          path: '/meus-pacientes/:id/:idservico/avaliacao-psicologica/declaracao/:idassessment',
          component: Declaration,
          meta: { auth: true }
        },
        {
          path: '/documentos',
          component: Documents,
          meta: { auth: true }
        },
        {
          path: '/documento',
          component: Document,
          meta: { auth: true }
        },
        {
          path: '/construtos',
          component: Construtos,
          meta: { auth: true }
        },
        {
          path: '/construto',
          component: Construto,
          meta: { auth: true }
        },
        {
          path: '/testes',
          component: Tests,
          meta: { auth: true }
        },
        {
          path: '/teste',
          component: Test,
          meta: { auth: true }
        },
        {
          path: '/fatores',
          component: Factors,
          meta: { auth: true }
        },
        {
          path: '/fator',
          component: Factor,
          meta: { auth: true }
        },
        {
          path: '/cadastro-de-teste',
          component: NewTest,
          meta: { auth: true }
        },
        {
          path: '/cadastro-de-construto',
          component: NewConstruct,
          meta: { auth: true }
        },
        {
          path: '/novo-teste',
          component: CreateTestFactory,
          meta: { auth: true }
        },
        {
          path: '/novo-construto',
          component: CreateConstructFactory,
          meta: { auth: true }
        },
        {
          path: '/relacionar-teste-x-construto',
          component: ConstructXTest,
          meta: { auth: true }
        }

        // { path: "*", component: PageNotFound },
      ]
    }
  ]

  return (
    <GuardProvider guards={[guardsRoutes]} error={PageNotFound}>
      <RouteFactory routes={routes} />
    </GuardProvider>
  )
}

export default Routes
